import { Data } from 'signup-constants/signupData/Data';
import { Step } from 'signup-constants/Step';
import { getSignupDataGtkmData, getSignupDataValue } from '../store/signup-data/selectors';
import { setNextSteps, goNextStep, replaceCurrentStep } from '../store/flow/action-creators';
import { getCurrentStep, getPostAccountCreationSteps, getPostExistingAccountSelectionSteps, getPostVerificationSteps, getPreVerificationSteps } from '../store/flow/selectors';
import { Tracker } from '../store/tracking/action-creators';
import { EndpointKey } from '../http/EndpointKey';
import { isEndpointStatusError } from '../store/http-responses/selectors';
import { AppKey } from '../app/AppKey';
import { getAppKeyValue } from '../store/app/selectors';
import { isOAuthSignup } from '../app/verificationTypeSelectors';
import { getShouldAddHubletSelection } from '../flow-branches/branches/BranchAddHubletNewUser';
import { getIsJapan } from '../utils/getIsJapan';
const hasValidDomain = gtkmData => {
  const domain = gtkmData[Data.CompanyDomain];
  return domain && domain.trim() !== '';
};
export const getPostGTKMFlowSU0004 = state => {
  var _getAppKeyValue;
  const isGTKMEndpointFailed = isEndpointStatusError(EndpointKey.GTKMCompanyInfoSU0004)(state);
  const isFreeEmailDomain = (_getAppKeyValue = getAppKeyValue(AppKey.IsFreeEmailDomain)(state)) !== null && _getAppKeyValue !== void 0 ? _getAppKeyValue : false;
  const gtkmDomain = getSignupDataGtkmData(state, Data.CompanyDomain);
  const gtkmData = {
    [Data.CompanyDomain]: gtkmDomain !== null && gtkmDomain !== void 0 ? gtkmDomain : null
  };
  const hasValidDomainResult = hasValidDomain(gtkmData);
  const needsDomainStep = !hasValidDomainResult || isFreeEmailDomain || isGTKMEndpointFailed;
  const firstName = getSignupDataValue(state, Data.FirstName);
  const lastName = getSignupDataValue(state, Data.LastName);
  const postAccountCreation = getPostAccountCreationSteps(state);
  const hasInstallSalesExtension = postAccountCreation.includes(Step.InstallSalesExtension);
  return [...(isOAuthSignup(state) ? [] : [Step.Password]), ...(isOAuthSignup(state) && firstName && lastName ? [] : [Step.Name]), Step.ManagementLevel, ...(needsDomainStep ? [Step.CompanyDomain] : []), Step.Review, ...(getIsJapan(state) ? [Step.PhoneNumber] : []), ...(getShouldAddHubletSelection(state) ? [Step.HubletSelection] : []), ...(hasInstallSalesExtension ? [Step.InstallSalesExtension] : [])];
};
export const updateStepOrderSU0004 = ({
  gtkmData,
  dispatch,
  state,
  isFreeEmailDomain = false,
  isGTKMEndpointFailed = false
}) => {
  const hasValidDomainResult = hasValidDomain(gtkmData);
  const needsDomainStep = !hasValidDomainResult || isFreeEmailDomain || isGTKMEndpointFailed;
  const firstName = getSignupDataValue(state, Data.FirstName);
  const lastName = getSignupDataValue(state, Data.LastName);
  const shouldAddPhoneNumber = getIsJapan(state);
  const postAccountCreation = getPostAccountCreationSteps(state);
  const hasInstallSalesExtension = postAccountCreation.includes(Step.InstallSalesExtension);
  const allSteps = [...(isOAuthSignup(state) ? [] : [Step.Password]), ...(isOAuthSignup(state) && firstName && lastName ? [] : [Step.Name]), Step.ManagementLevel, ...(needsDomainStep ? [Step.CompanyDomain] : []), Step.Review, ...(shouldAddPhoneNumber ? [Step.PhoneNumber] : []), ...(getShouldAddHubletSelection(state) ? [Step.HubletSelection] : []), ...(hasInstallSalesExtension ? [Step.InstallSalesExtension] : [])];
  const currentStep = getCurrentStep(state);
  if (currentStep === Step.LoadingPage) {
    dispatch(replaceCurrentStep(allSteps[0]));
    dispatch(setNextSteps(allSteps.slice(1)));
  } else if (isGTKMEndpointFailed && currentStep === Step.CompanyDomain) {
    const hubletSteps = getShouldAddHubletSelection(state) ? [Step.HubletSelection] : [];
    const phoneSteps = shouldAddPhoneNumber ? [Step.PhoneNumber] : [];
    const installSteps = hasInstallSalesExtension ? [Step.InstallSalesExtension] : [];
    dispatch(goNextStep({
      step: Step.Review,
      nextSteps: [...phoneSteps, ...hubletSteps, ...installSteps],
      preVerificationSteps: getPreVerificationSteps(state),
      postVerificationSteps: getPostVerificationSteps(state),
      postAccountCreationSteps: postAccountCreation,
      postExistingAccountSelectionSteps: getPostExistingAccountSelectionSteps(state)
    }));
  } else if (currentStep) {
    const currentStepIndex = allSteps.indexOf(currentStep);
    const stepsAfterCurrent = currentStepIndex >= 0 ? allSteps.slice(currentStepIndex + 1) : allSteps;
    dispatch(setNextSteps(stepsAfterCurrent));
  } else {
    dispatch(setNextSteps(allSteps));
  }
  return allSteps;
};

// Advance from CompanyDomain to LoadingPage so the user sees a spinner while
// the second GTKM call is in flight (mirrors the first-call bridge).
export const advanceToLoadingPageAfterDomainSU0004 = ({
  dispatch,
  state
}) => {
  dispatch(Tracker.signupInteraction('su0004-gtkm-advance-to-loading-after-domain'));
  const hubletSteps = getShouldAddHubletSelection(state) ? [Step.HubletSelection] : [];
  const phoneSteps = getIsJapan(state) ? [Step.PhoneNumber] : [];
  const postAccountCreation = getPostAccountCreationSteps(state);
  const installSteps = postAccountCreation.includes(Step.InstallSalesExtension) ? [Step.InstallSalesExtension] : [];
  const remainingSteps = [Step.Review, ...phoneSteps, ...hubletSteps, ...installSteps];
  dispatch(goNextStep({
    step: Step.LoadingPage,
    nextSteps: remainingSteps,
    preVerificationSteps: getPreVerificationSteps(state),
    postVerificationSteps: getPostVerificationSteps(state),
    postAccountCreationSteps: postAccountCreation,
    postExistingAccountSelectionSteps: getPostExistingAccountSelectionSteps(state)
  }));
  return [Step.LoadingPage, ...remainingSteps];
};

// Advance to Review after the second GTKM call resolves (success or error),
// or when the user resubmits the same domain and no second call is needed.
// When called from the LoadingPage bridge, use replaceCurrentStep so the
// transient spinner step isn't pushed onto prevFlowStates (otherwise Back
// from Review would strand the user on LoadingPage).
export const advanceToReviewAfterDomainSU0004 = ({
  dispatch,
  state
}) => {
  dispatch(Tracker.signupInteraction('su0004-gtkm-advance-to-review-after-domain'));
  const currentStep = getCurrentStep(state);
  const hubletSteps = getShouldAddHubletSelection(state) ? [Step.HubletSelection] : [];
  const phoneSteps = getIsJapan(state) ? [Step.PhoneNumber] : [];
  const postAccountCreation = getPostAccountCreationSteps(state);
  const installSteps = postAccountCreation.includes(Step.InstallSalesExtension) ? [Step.InstallSalesExtension] : [];
  const remainingSteps = [Step.Review, ...phoneSteps, ...hubletSteps, ...installSteps];
  const stepsAfterReview = [...phoneSteps, ...hubletSteps, ...installSteps];
  if (currentStep === Step.LoadingPage) {
    dispatch(replaceCurrentStep(Step.Review));
    dispatch(setNextSteps(stepsAfterReview));
    return remainingSteps;
  }
  dispatch(setNextSteps(remainingSteps));
  dispatch(goNextStep({
    step: Step.Review,
    nextSteps: stepsAfterReview,
    preVerificationSteps: getPreVerificationSteps(state),
    postVerificationSteps: getPostVerificationSteps(state),
    postAccountCreationSteps: postAccountCreation,
    postExistingAccountSelectionSteps: getPostExistingAccountSelectionSteps(state)
  }));
  return remainingSteps;
};